import React from 'react'
import PropTypes from 'prop-types'
import AusbildungsplanSubmenuAsAusbilder from './AusbildungsplanSubmenuAsAusbilder'
import AusbildungsplanSubmenuAsAzubi from './AusbildungsplanSubmenuAsAzubi'
import {usePermissions} from '#hooks/usePermissions'

function AusbildungsplanSubmenu(props) {
  const {pathParts, currentUserId, contextualUserId} = props

  const isAusbildungsplan = pathParts[0] === 'ausbildungsplan'

  const permissions = usePermissions()
  if (!isAusbildungsplan) {
    return null
  }

  if (permissions.ausbildungsplan.viewAusbildungsplanFromOthers) {
    return (
      <AusbildungsplanSubmenuAsAusbilder
        pathParts={pathParts}
        currentUserId={currentUserId}
        contextualUserId={contextualUserId}
      />
    )
  }

  return (
    <AusbildungsplanSubmenuAsAzubi
      pathParts={pathParts}
      currentUserId={currentUserId}
      contextualUserId={contextualUserId}
    />
  )
}

AusbildungsplanSubmenu.propTypes = {
  pathParts: PropTypes.array.isRequired,
  currentUserId: PropTypes.number.isRequired,
  contextualUserId: PropTypes.number,
}

export default AusbildungsplanSubmenu
